




























import {Component, Prop, Vue} from 'vue-property-decorator'

interface TestimonialEntry {
    name: string;
    imgUrl?: string;
    message: string;
}

@Component
export default class Testimonials extends Vue {

    @Prop()
    entries!: TestimonialEntry[];

    private currentIndex = 0;

    private get currentEntry(): TestimonialEntry {
        return this.entries[this.currentIndex];
    }

    private get showMobileLayout(): boolean {
        return window.innerWidth < 500;
    }

    private nextEntry() {
        if (this.currentIndex < this.entries.length - 1) {
            this.currentIndex++;
        } else {
            this.currentIndex = 0;
        }
    }

    private prevEntry() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        } else {
            this.currentIndex = this.entries.length - 1;
        }
    }
}
